import {
  getStageStatusColor,
  STAGE_STATUS_TEXT,
} from "@/features/assignment/lib";
import { StageDetailStatus, StageStatus } from "@/shared/api";
import { Badge, Card, DataList, Text } from "@radix-ui/themes";
import { TooltipProps } from "recharts";

function CustomTooltipContent({
  payload,
  label,
}: TooltipProps<string, string>) {
  const findStageStatus = (stage: string) => {
    const stageDetailStatuses = payload?.[0].payload?.stage_detail_statuses;
    const stageDetailStatus = stageDetailStatuses?.find(
      (item: StageDetailStatus) => item.stage === stage
    );
    return stageDetailStatus?.status as StageStatus;
  };

  const pinBasedF1Score = payload?.[0].payload?.pin_based_f1_score;
  const zoneBasedF1Score = payload?.[0].payload?.zone_based_f1_score;
  const pipelineVersion = payload?.[0].payload?.pipeline_version;

  return (
    <Card className="shadow-lg relative z-[9999]">
      <DataList.Root className="gap-y-2" size="1">
        <DataList.Item>
          <DataList.Label>Order ID</DataList.Label>
          <DataList.Value>{payload?.[0].payload.order_id}</DataList.Value>
        </DataList.Item>
        <DataList.Item>
          <DataList.Label>Order Source</DataList.Label>
          <DataList.Value>{payload?.[0].payload.order_source}</DataList.Value>
        </DataList.Item>
        <DataList.Item>
          <DataList.Label>Journey Count</DataList.Label>
          <DataList.Value>{payload?.[0].payload.journeys_count}</DataList.Value>
        </DataList.Item>
        <DataList.Item>
          <DataList.Label>Unique SKU Annotations</DataList.Label>
          <DataList.Value>{payload?.[0].payload.skus_count}</DataList.Value>
        </DataList.Item>
        <DataList.Item>
          <DataList.Label>Stage Journey Annotation</DataList.Label>
          <DataList.Value>
            <Badge
              color={getStageStatusColor(findStageStatus("journey_annotation"))}
            >
              {STAGE_STATUS_TEXT[findStageStatus("journey_annotation")]}
            </Badge>
          </DataList.Value>
        </DataList.Item>
        <DataList.Item>
          <DataList.Label>Stage Transaction Annotation</DataList.Label>
          <DataList.Value>
            <Badge
              color={getStageStatusColor(
                findStageStatus("transaction_annotation")
              )}
            >
              {STAGE_STATUS_TEXT[findStageStatus("transaction_annotation")]}
            </Badge>
          </DataList.Value>
        </DataList.Item>
        <DataList.Item>
          <DataList.Label>Stage Track Persistence Annotation</DataList.Label>
          <DataList.Value>
            <Badge
              color={getStageStatusColor(
                findStageStatus("track_persistence_annotation")
              )}
            >
              {
                STAGE_STATUS_TEXT[
                  findStageStatus("track_persistence_annotation")
                ]
              }
            </Badge>
          </DataList.Value>
        </DataList.Item>
        <DataList.Item className="pb-2 border-b border-[var(--gray-a4)]">
          <DataList.Label>Anomaly Report</DataList.Label>
          <DataList.Value>
            <Text className="truncate max-w-[250px]">
              {payload?.[0].payload.anomaly_report || "-"}
            </Text>
          </DataList.Value>
        </DataList.Item>
        {pipelineVersion !== undefined && (
          <DataList.Item>
            <DataList.Label>Pipeline Version</DataList.Label>
            <DataList.Value>{pipelineVersion}</DataList.Value>
          </DataList.Item>
        )}
        <DataList.Item>
          <DataList.Label>Requested at</DataList.Label>
          <DataList.Value>{label}</DataList.Value>
        </DataList.Item>
        {pinBasedF1Score !== undefined && (
          <DataList.Item>
            <DataList.Label>Pin based F1 score</DataList.Label>
            <DataList.Value>{pinBasedF1Score}</DataList.Value>
          </DataList.Item>
        )}
        {zoneBasedF1Score !== undefined && (
          <DataList.Item>
            <DataList.Label>Zone based F1 score</DataList.Label>
            <DataList.Value>{zoneBasedF1Score}</DataList.Value>
          </DataList.Item>
        )}
      </DataList.Root>
    </Card>
  );
}

export function CustomTooltip({
  active,
  payload,
  label,
}: TooltipProps<string, string>) {
  if (active && payload && payload.length) {
    return <CustomTooltipContent payload={payload} label={label} />;
  }

  return null;
}
